module.exports = __webpack_public_path__ + "static/RemoteWorkforce-8d36d382a31d439fd4ade2bccbd8d3ac.png";